import CryptoJS from 'crypto-js';

let secretKey = 'mySecretKey20209';
// AES加密函数
const encrypt = (plaintext: string, key: string, iv: string) => {
  
  try {
      // 使用CBC模式和PKCS7填充进行加密
      const encrypted = CryptoJS.AES.encrypt(plaintext, 
          CryptoJS.enc.Utf8.parse(key || secretKey), {
              iv: CryptoJS.enc.Utf8.parse(iv || secretKey),
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7
          });
      
      // 获取Base64格式的密文
      const ciphertext = encrypted.toString();
      return ciphertext;
  } catch (error: any) {  
      console.log('加密失败: ' + error.message);
      return null;
  }
}

// AES解密函数
const decrypt = (ciphertext: string, key: string, iv: string) => {
  try {
      // 使用CBC模式和PKCS7填充进行解密
      const decrypted = CryptoJS.AES.decrypt(ciphertext, 
          CryptoJS.enc.Utf8.parse(key || secretKey), {
              iv: CryptoJS.enc.Utf8.parse(iv || secretKey),
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7
          });
      
      // 将解密结果转换为UTF-8字符串
      const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
      return plaintext;
      
  } catch (error: any) {
      console.log('解密失败: ' + error.message);
      return null;
  }
}

// 生成参数签名
const generateSignature = (params: Object,customSecretKey?: string) => {
  // 将参数转换为字符串
  const paramStr = JSON.stringify(params);
  
  // 使用AES加密生成签名
  const signature = CryptoJS.AES.encrypt(paramStr, customSecretKey || secretKey).toString();
  
  return signature;
}

const checkSignature = (params: Object,signature: string,customSecretKey?: string) => {
  // 将参数转换为字符串
  const paramsStr = JSON.stringify(params);
  
  // 解密签名
  const decrypted = CryptoJS.AES.decrypt(signature, customSecretKey || secretKey).toString(CryptoJS.enc.Utf8);
  // 比较解密后的数据与原始参数是否完全一致
  return paramsStr === decrypted;
}


const releaseSignature = (signature: string,customSecretKey?: string) => {  // 解密签名
  const decrypted = CryptoJS.AES.decrypt(signature, customSecretKey || secretKey).toString(CryptoJS.enc.Utf8);
 
  return decrypted;
}

export { encrypt, decrypt,generateSignature,checkSignature, releaseSignature };